<template>
    <div class="form">
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('demo.headline.general') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label label--required" for="language_mail">
                        {{ trans('demo.label.language_mail') }}
                    </label>
                    <v-select v-model="languageMail"
                        :options="languageOptions"
                        :clearable="false"
                        class="form-vue-select"
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                    <input name="language_mail" :value="languageMail.value" hidden>
                </div>
            </div>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('demo.headline.client_information') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input v-model="name"
                        name="name"
                        :required="true"
                    >
                        {{ trans('clients.label.name') }}
                    </form-input>
                </div>
                <div class="form-row__col form-row__col--one-half">
                    <form-input v-model="email"
                        name="email"
                        :required="true"
                    >
                        {{ trans('clients.label.email') }}
                    </form-input>
                </div>
            </div>
        </section>

        <section class="form-section">
            <label class="form-section-heading">
                {{ trans('demo.headline.role') }}
            </label>

            <checkbox-wrapper name="roles[]">
                <checkbox-card :card="card" icon="/images/icon-user.svg" name="roles[]" v-for="(card, index) in clientRolesCheckboxes" :key="index"></checkbox-card>
            </checkbox-wrapper>
        </section>

        <section class="form-section">
            <label class="form-section-heading">
                {{ trans('demo.headline.course_assignment') }}
            </label>
            <extendable-card-list
                v-model="selectedCourses"
                v-slot="slot"
                :data-can-be-added="true"
                data-can-be-deleted
                data-can-be-edited
            >
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">{{ trans('clients.label.select_course') }}</label>
                        <v-select v-model="slot.data.course"
                            :options="allCourses"
                            class="form-vue-select"
                        >
                            <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                        </v-select>
                        <input :name="'selected_courses[' + slot.index + '][course_id]'" :value="slot.data.course ? slot.data.course.value : null" hidden>
                    </div>
                    <div class="form-row__col form-row__col--one-half" v-if="slot.data.course">
                        <label class="label">{{ trans('clients.label.select_coursevariation') }}</label>
                        <v-select v-model="slot.data.coursevariation"
                            :options="slot.data.course.variations"
                            class="form-vue-select"
                        >
                            <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                        </v-select>
                        <input :name="'selected_courses[' + slot.index + '][course_variation_id]'" :value="slot.data.coursevariation ? slot.data.coursevariation.value : null" hidden>
                    </div>
                </div>
            </extendable-card-list>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                <label>
                    {{ trans('demo.headline.attachments') }}
                </label>
            </div>
            <checkbox class="h:margin-bottom-8" name="attachments[flyer]" value="1" :checked="true">
                {{ trans('demo.attachments.flyer') }}{{ fileInOtherLanguage.flyer }}
            </checkbox>
            <checkbox class="h:margin-bottom-8" name="attachments[catalogue]" value="1" :checked="true">
                {{ trans('demo.attachments.catalogue') }}{{ fileInOtherLanguage.catalogue }}
            </checkbox>
            <checkbox class="h:margin-bottom-8" name="attachments[pricelist]" value="1" :checked="true">
                {{ trans('demo.attachments.pricelist') }}{{ fileInOtherLanguage.pricelist }}
            </checkbox>
            <checkbox class="h:margin-bottom-8" name="attachments[workflow]" value="1" :checked="true">
                {{ trans('demo.attachments.workflow') }}{{ fileInOtherLanguage.workflow }}
            </checkbox>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <a
                    :href="route('dashboard')"
                    class="btn btn--big btn--tertiary">
                        {{ trans('buttons.back') }}
                </a>
            </div>
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary" :disabled="disableSubmit">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    props: [
        'courses',
    ],

    data() {
        return {
            name: '',
            email: '',
            fields: {
                roles: [],
            },
            allCourses: this.courses.map((course) => {
                return {
                    'value': course.course_id,
                    'label': course.course_title,
                    'variations': course.variations.map((coursevar) => {
                        return {
                            'value': coursevar.is_default ? null : coursevar.id,
                            'label': coursevar.variation_name + (coursevar.is_default ? ' (' + this.trans('courses.label.default_variation') + ')' : ''),
                        };
                    }),
                };
            }),
            selectedCourses: [],
            languageOptions: [
                {'value': 'de', 'label': 'Deutsch'},
                {'value': 'en', 'label': 'Englisch'},
            ],
            languageMail: {'value': 'de', 'label': 'Deutsch'},
        };
    },

    computed: {
        clientRolesCheckboxes() {
            return [
                {
                    'value': '5',
                    'title': this.trans('users.role.client_admin'),
                    'description': this.descriptionText(this.trans('users.role_description.client_admin')),
                    'status': this.fields.roles.includes(5),
                },
                {
                    'value': '6',
                    'title': this.trans('users.role.controller'),
                    'description': this.descriptionText(this.trans('users.role_description.controller')),
                    'status': this.fields.roles.includes(6),
                },
                {
                    'value': '7',
                    'title': this.trans('users.role.end_user'),
                    'description': this.descriptionText(this.trans('users.role_description.end_user')),
                    'status': this.fields.roles.includes(7),
                },
            ];
        },

        fileInOtherLanguage() {
            return {
                'flyer': (this.languageMail.value == 'en') ? ' (de)' : '',
                'catalogue': '',
                'pricelist': '',
                'workflow': (this.languageMail.value == 'en') ? ' (de)' : '',
            };
        },

        disableSubmit() {
            // disable if name or email is empty
            if (this.name == '' || this.email == '') {
                return true;
            }
            // disable if selected courses is empty (no course selected yet)
            if (!this.selectedCourses.length) {
                return true;
            }
            // disable if one selected course has no coursevariation chosen
            if (!this.selectedCourses.every(item => item.coursevariation != null)) {
                return true;
            }
            return false;
        }
    },

    methods: {
        test(index) {
            if (this.selectedCourses[index].coursevariation) {
                this.selectedCourses[index].coursevariation = null;
            }
            this.preselectDemoVar(index);
        },
        preselectDemoVar(index) {
            if (this.selectedCourses[index].course) {
                var demovar = this.selectedCourses[index].course.variations.find(coursevar => {
                    return coursevar.label == 'Demo';
                });
                if (demovar != undefined) {
                    this.selectedCourses[index].coursevariation = demovar;
                }
            }
        },
        descriptionText(descriptionsArray) {
            var descriptionHtml = "<ul>";

            descriptionsArray.forEach(descriptionLine => {
                descriptionHtml += "<li>" + descriptionLine + "</li>";
            });

            return (descriptionHtml + "</ul>");
        },
    },

    mounted() {
        EventBus.$on('checkboxesChanged', (roles) => {
            if (roles.name == 'roles[]') {
                this.fields.roles = roles.data.filter(array=>{
                    return array.status == true
                }).map(array => {
                    return array.value
                });
            }
        });
    },
}
</script>
